const set = require('regenerate')(0xB7);
set.addRange(0x964, 0x96F).addRange(0xA830, 0xA839).addRange(0x11150, 0x11176);
exports.characters = set;
